import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import Header from './Header';

const privacyStyles = {
  maxWidth: '800px',
  paddingLeft: '30px',
  paddingRight: '30px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '60px'
}

const Privacy = ({ appKey }) => {
  const [markdownContent, setMarkdownContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        setLoading(true);
        setError(null);
        const lang = (i18n.resolvedLanguage || i18n.language || 'en').toLowerCase();
        const currentLanguage = lang.startsWith('ko') ? 'ko' : 'en';

        // 마크다운 파일 경로 생성
        const markdownPath = `/policies/${currentLanguage}/${appKey}.md`;

        const response = await fetch(markdownPath);

        if (!response.ok) {
          throw new Error(`Failed to fetch policy: ${response.status}`);
        }

        const content = await response.text();
        const trimmedContent = content.trim().toLowerCase();

        // Netlify redirect 등으로 index.html이 내려온 경우를 차단
        if (
          trimmedContent.startsWith('<!doctype html') ||
          trimmedContent.includes('<div id="root"></div>')
        ) {
          throw new Error('Policy content is invalid (received HTML shell instead of markdown).');
        }

        setMarkdownContent(content);
      } catch (err) {
        console.error('Error fetching markdown:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMarkdown();
  }, [appKey, i18n.language, i18n.resolvedLanguage]);

  if (loading) {
    return (
      <>
        <Header appKey={appKey} />
        <div style={privacyStyles}>
          <p>Loading privacy policy...</p>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header appKey={appKey} />
        <div style={privacyStyles}>
          <p>Error loading privacy policy: {error}</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Header appKey={appKey} />
      <div style={privacyStyles}>
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
        <div style={{ marginBottom: '100px' }} />
      </div>
    </>
  );
};

export default Privacy;
